import { runInAction } from "mobx";
import { ObservableService } from "../services/ObservableService";
import StoreService from "../services/StoreService";

const initialState = {
  isLoggedIn: false,
  isTokenExpired: false,
}

export const sessionStore = ObservableService.persistentObservable("SessionStore", () => initialState, 604800);

export function clear() {
  runInAction(() => {
    sessionStore.userId = undefined;
    sessionStore.token = undefined;
    sessionStore.isLoggedIn = false;
    sessionStore.isTokenExpired = false;
  });
}

StoreService.onLogout(clear);